import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_number } from '@/state/ui/_base/LOCAL__ui_set_number';
import { useEffect, useRef } from 'react';
import { ENUM__image_brush } from './ENUM__image_brush';

export function WATCHER__change_brush_size_by_scroll() {
  const dispatch = use_dispatch();

  /*
   * STORE
   */
  const { g_image_edit__brush_size, g_image_edit__brush } = use_slice_ui(['g_image_edit__brush_size', 'g_image_edit__brush']);

  /*
   * STATE
   */
  const ref_brush_size = useRef(g_image_edit__brush_size);

  /*
   * EFFECTS
   */
  useEffect(() => {
    ref_brush_size.current = g_image_edit__brush_size;
  }, [g_image_edit__brush_size]);

  function on_wheel(event: WheelEvent) {
    if (g_image_edit__brush == ENUM__image_brush.POINTER) return;

    event.preventDefault();

    const direction = event.deltaY < 0 ? 1 : -1;

    let STEP_SIZE = 25;

    const value_target = ref_brush_size.current + direction * STEP_SIZE;
    const value_next = CONSTANTS__client.IMAGE_BRUSH_SIZE_RANGE.clamp(value_target);

    if (value_next !== ref_brush_size.current) {
      dispatch(LOCAL__ui_set_number({ key: 'g_image_edit__brush_size', value: value_next }));
    }
  }

  useEffect(() => {
    window.addEventListener('wheel', on_wheel, { passive: false });

    return () => window.removeEventListener('wheel', on_wheel);
  }, [on_wheel]);

  return null;
}
